export const TRANSCRIPTION = 'transcription';
export const TRANSLATION = 'translation';
export const CAPTIONS = 'captions';
export const TRANSLATED_SUBTITLES = 'translatedSubtitles';
